// Copy for the home page (Home.jsx) — English translation of fr/home.js.
// Same keys, same order. Brand names (Joyful Reveal, Mirum Games) stay as they
// are; the pack names follow the ones set in en/common.js.
export default {
  'home.seo.titre': 'Joyful Reveal - Gender reveal game: play to reveal your baby’s sex | Mirum Games',
  'home.seo.description': 'Turn your gender reveal party into a game: 2 teams, funny questions, 11 puzzle pieces to win and a final piece that reveals your baby’s sex. Fast delivery in Belgium and France.',

  'home.etat.chargement': 'Loading...',

  'home.vitrine.badge': '🧩 Our collection',
  'home.vitrine.description': 'A one-of-a-kind concept that turns your baby’s gender reveal into a fun question-and-answer game! Gather your loved ones, form teams and share a magical moment you will all remember for years.',
  'home.vitrine.altProduit': 'Joyful Reveal Bears - Eco-friendly puzzle revealing your baby’s sex - Mirum Games',

  'home.packs.titre': 'Choose your pack',
  'home.packs.economisez': 'Save {pct}%',
  'home.packs.selectionne': '✓ Selected',
  'home.packs.selectionner': 'Select',
  'home.packs.voirFiche': '📋 See the full product page',

  'home.recap.packChoisi': 'Pack chosen:',
  'home.recap.prixTotal': 'Total price:',

  'home.genre.cestPour': 'It’s for...',
  'home.genre.contenuPack': 'What’s in the pack',
  'home.genre.packMixte': 'Mixed pack: girl + boy included!',
  'home.genre.versionGarcon': 'Boy version pre-selected',
  'home.genre.versionFille': 'Girl version pre-selected',

  // Variant labels: used for the Boy/Girl buttons AND for the composed product
  // name added to the basket (one key per variant).
  'home.variante.garcon': 'Boy',
  'home.variante.fille': 'Girl',
  'home.variante.mixte': 'Girl + Boy',

  'home.cta.ajouterPanier': '🛒 Add to basket',
  'home.cta.voirFichePack': '📋 See the full product page for the {pack}',
  'home.cta.magique': '✨ Create a magical moment with your family',

  'home.badges.cleEnMain': 'Ready to Play',
  'home.badges.pretAOffrir': 'Ready to Gift',
  'home.badges.livraisonRapide': 'Fast Delivery',

  'home.concept.badge': '✨ Our unique concept',
  // Sentences split around the <strong>: before / strong word / after.
  'home.concept.question': 'A little girl? A little boy?',
  'home.concept.questionSuite': 'Is everyone around you dying to know which team your baby will be on?',
  'home.concept.annonce': 'Share the news in a playful, original way with our game!',
  'home.concept.puzzleAvant': 'This puzzle is',
  'home.concept.puzzleMot': 'unique',
  'home.concept.puzzleApres': 'because you build it by playing a fun question-and-answer game, and it ends up revealing baby’s little secret.',
  'home.concept.experienceAvant': 'Far more than a puzzle, this is an',
  'home.concept.experienceMot': 'experience full of sharing and joy',
  'home.concept.experienceApres': 'with friends and family. Gather your loved ones, form teams and enjoy this once-in-a-lifetime moment!',
  'home.concept.cadeauAvant': 'Whether you are the parents-to-be yourselves or you are throwing a',
  'home.concept.cadeauMot': 'Gender Reveal Party',
  'home.concept.cadeauApres': 'for someone you love, our game is guaranteed to make the day even more memorable.',

  'home.instagram.badge': '📸 Magical moments',
  'home.instagram.titre': 'See our puzzle in action! 🎉',
  'home.instagram.sousTitre': 'Watch how our customers live their magical reveal with Joyful Reveal',
  'home.instagram.altReel': 'Two parents-to-be surrounded by puzzle pieces, Joyful Reveal illustration',
  'home.instagram.voirSur': 'View on Instagram',
  'home.instagram.momentTitre': 'An unforgettable moment',
  'home.instagram.momentTexte': 'Our puzzles turn the reveal into an interactive, festive experience. Put the pieces together as a family and discover the big secret at the same time!',
  'home.instagram.jeuInteractif': 'Interactive game',
  'home.instagram.enFamille': 'With the whole family',
  'home.instagram.suivezNous': 'Follow us on Instagram',
};
